import * as React from 'react'
import styled from 'styled-components'

import Modal from '../../ui/Modal/Modal'
import media from '../../../services/generateMediaQueries'
import ActionButton from '../../ui/ActionButton/ActionButton'
import TncModalBackground from '../../../assets/img/tnc-modal-background.png'
import { Description as TnCAndPNConsentDescription } from '../../../views/webview.tnc-and-pn-consent/components/TnCAndPNConsent/TnCAndPNConsent'

const StyledModal = styled(Modal)`
  max-width: 480px !important;
  background: center / cover no-repeat url('${TncModalBackground}'), #ffffff !important;

  ${media.lessThan('small')`
    max-width: 100%;
    border-radius: 0;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-height: calc(100vh - 40px);

  ${media.lessThan('small')`
    max-height: 100vh;
    width: 100vw;
  `}
`

const Content = styled.div`
  flex-shrink: 1;
  font-size: 0.875rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-right: 1rem;
  margin-right: -1rem;
  line-height: 2;

  &::-webkit-scrollbar {
    border-radius: 0.5rem;
    width: 0.5rem;
    background-color: #ebebeb;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: var(--color-primary);
  }
`

const AgreeButton = styled(ActionButton)`
  margin-top: 1.25rem;
  padding: 1rem 2rem;
`

function TnCAndPNModal({ show, zIndex, onClose, onAgree }) {
  return (
    <StyledModal
      id="tncAndPNModal"
      zIndex={zIndex}
      show={show}
      hasCloseButton={false}
      handleClose={e => {
        e.stopPropagation()
        // onClose(e)
      }}
    >
      <Container>
        <Content>
          <TnCAndPNConsentDescription />
        </Content>
        {onAgree && (
          <AgreeButton variant="primary" onClick={onAgree}>
            Agree
          </AgreeButton>
        )}
      </Container>
    </StyledModal>
  )
}

export default TnCAndPNModal
